// The same chevron as ChevronRightIconV2, mirrored the way the source svg does it
// -- a scale(-1, 1) about the glyph's own centre rather than a rotation.
export const ChevronLeftIconV2 = (props) => (
  <svg fill="none" height={16} viewBox="-5 0 23 23" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="currentColor" fillRule="nonzero" transform="translate(-564, -39)">
      <path
        d="M565.76062,39.2902857 L576.638635,49.7417043 L576.699713,49.7959169 C576.885605,49.9745543 576.985701,50.2044182 577,50.4382227 L577,50.5617773 C576.985701,50.7955818 576.885605,51.0254457 576.699713,51.2040831 L576.646163,51.2479803 L565.76062,61.7097143 C565.357854,62.0967619 564.704841,62.0967619 564.302075,61.7097143 C563.899308,61.3226668 563.899308,60.6951387 564.302075,60.3080911 L574.451352,50.5617773 L564.302075,40.6919089 C563.899308,40.3048613 563.899308,39.6773332 564.302075,39.2902857 C564.704841,38.9032381 565.357854,38.9032381 565.76062,39.2902857 Z"
        transform="translate(570.5, 50.5) scale(-1, 1) translate(-570.5, -50.5)"
      />
    </g>
  </svg>
);
